import React, { useEffect } from "react";
import { actionCreators } from "./redux/remainingSessionsSagas";
import { useDispatch, useSelector } from "react-redux";

import LoadingAnimation from "../../components/loadingAnimation/loadingAnimation";
import SectionToggle from "../../components/sectionToggle/sectionToggle";
import PieChart from "../../components/charts/pieChart/pieChart";
import { DataPoints } from "./smartComponents/DataPoints";
import MembershipTypeFilter from "./smartComponents/MembershipTypeFilter";
import RemainingSessionsFilter from "./smartComponents/RemainingSessionsFilter";
import ReactDatePicker from "../../components/reactDatePicker/reactDatePicker";
import RemainingSessionTable from "./smartComponents/RemainingSessionsTable";
import ViewFilter from "./smartComponents/ViewFilter";
import ProspectTypeFilter from "./smartComponents/ProspectTypeFilter";
import KBLearnMore from "../../components/learnMore/KBLearnMore";
import { ILEARN_URLS } from "../../constants/ilearnUrls";
import CategoriesFilter from "./smartComponents/CategoriesFilter";
import { UpdateButtons } from "./smartComponents/UpdateButtons";
import GroupBy from "./smartComponents/GroupBy";
import { useDateFormat } from "../../hooks/useDateFormat";
import NoData from "../../components/noData/noData";
import "./remainingSessions.scss";

const RemainingSessionsModule = (props) => {
  const dispatch = useDispatch();
  const dateFormat = useDateFormat();

  const {
    isLoading,
    updatesLoading,
    filters: { membership_types = [], prospect_types = [] },
    chartValues,
    currentUser: { useSecondaryCategories }
  } = useSelector((state) => state.sessions);
  const selectedView = useSelector((state) => state.sessions.selectedFilters.view);

  const disableUpdateButton =
    (selectedView === "Membership Type" && !membership_types.length) ||
    (selectedView === "Prospect Type" && !prospect_types.length);

  useEffect(() => {
    dispatch(actionCreators.fetchCurrentUser(props));
  }, []);

  const content = () => {
    return (
      <div>
        <div id="override-edit-selection-bar" className="edit-selections-bar">
          <div className="top-filters">
            <div className="left-side">
              {membership_types.length || prospect_types.length ? (
                <>
                  <div className="select-box" style={{ width: "160px" }}>
                    <p className="offers-title">View</p>
                    <ViewFilter />
                  </div>
                  {selectedView === "Category" ? (
                    <>
                      {useSecondaryCategories && (
                        <CategoriesFilter filter="primary_categories" name="Primary Category" />
                      )}
                      <CategoriesFilter
                        filter="secondary_categories"
                        name={`${useSecondaryCategories ? "Secondary" : ""} Category`}
                      />
                      <CategoriesFilter filter="sales_packages" name="Sales Package" />
                      <div className="select-box" style={{ width: "180px" }}>
                        <p className="offers-title">Group By</p>
                        <GroupBy />
                      </div>
                    </>
                  ) : selectedView === "Membership Type" ? (
                    <div className="select-box" style={{ width: "160px" }}>
                      <p className="offers-title">Membership Types</p>
                      <MembershipTypeFilter />
                    </div>
                  ) : (
                    <div className="select-box" style={{ width: "160px" }}>
                      <p className="offers-title">Prospect Types</p>
                      <ProspectTypeFilter />
                    </div>
                  )}

                  <div className="select-box" style={{ width: "160px" }}>
                    <p className="offers-title">Remaining Session</p>
                    <RemainingSessionsFilter />
                  </div>
                </>
              ) : null}
            </div>

            <div className="right-side">
              <ReactDatePicker
                displayFormat={dateFormat}
                calendarEndDate={props.calendarEndDate}
                disabled
                startDate={props.calendarEndDate}
              />
            </div>
          </div>
          <UpdateButtons params={props} disableUpdateButton={disableUpdateButton} />
        </div>
        {updatesLoading ? (
          <LoadingAnimation text="Updating data..." />
        ) : chartValues.length ? (
          <>
            <div className="pie-charts-wrapper">
              <DataPoints />
              {chartValues.map((values, idx) => (
                <div key={idx} className="pie-chart">
                  <PieChart
                    width={530}
                    height={300}
                    data={values}
                    legendPosition="right"
                    legendTooltipPosition="left"
                    showLegend
                    isLegendTooltip
                  />
                </div>
              ))}
            </div>
            <RemainingSessionTable />
          </>
        ) : (
          <NoData />
        )}
      </div>
    );
  };

  return (
    <div id="remainingSessionModule">
      <SectionToggle
        title="Remaining Sessions"
        isLoading={isLoading}
        content={content()}
        autoHeight
        learnMore={
          <KBLearnMore
            title="Remaining Sessions"
            description="This report shows how many sessions clients have remaining on their purchased packages, based on the most current data available. These insights help you monitor usage patterns, flag clients who may be nearing depletion, and anticipate future sales opportunities."
            kbUrl={ILEARN_URLS.sessions.remainingSessions}
          />
        }
      />
    </div>
  );
};

export default RemainingSessionsModule;
